import api from './apiClient';
import { SystemSetting, SystemSettingUpdatePayload, MenuPermissionsResponse, MenuConfigByRole, MenuConfigUpdateRequest } from '../types';

export const systemService = {
  getSettings: async (): Promise<SystemSetting[]> => {
    const response = await api.get('/system/settings');
    return response.data;
  },

  getMedicalControlLimits: async (): Promise<{
    reason_for_visit: number;
    symptoms: number;
    diagnosis: number;
    treatment_plan: number;
    recommendations: number;
    notes: number;
  }> => {
    const response = await api.get('/system/settings/public/medical-control-limits');
    return response.data;
  },

  getVaccinationLimits: async (): Promise<{
    notes: number;
    reaction_notes: number;
  }> => {
    const response = await api.get('/system/settings/public/vaccination-limits');
    return response.data;
  },

  getMedicalRecordLimits: async (): Promise<{
    title: number;
    description: number;
    notes: number;
  }> => {
    const response = await api.get('/system/settings/public/medical-record-limits');
    return response.data;
  },

  getPetFormLimits: async (): Promise<{
    biography: number;
    owner_name: number;
    owner_history_summary: number;
  }> => {
    const response = await api.get('/system/settings/public/pet-form-limits');
    return response.data;
  },

  getClinicalInterviewLimits: async (): Promise<{
    food_type: number;
    digestive_problems_detail: number;
    current_vaccines: number;
    antiparasitic_name: number;
    frequent_illnesses: number;
    chronic_diseases: number;
    allergies: number;
    regular_medications: number;
    blood_test_results: number;
    pending_veterinary_indications: number;
    surgeries: number;
    serious_illnesses_or_accidents: number;
    last_vet_consultation_reason: number;
    last_vet_consultation_observations: number;
  }> => {
    const response = await api.get('/system/settings/public/clinical-interview-limits');
    return response.data;
  },

  getLimits: async (type: 'medical-control' | 'vaccination' | 'medical-record' | 'pet-form' | 'clinical-interview' | 'registration'): Promise<Record<string, number>> => {
    const response = await api.get('/system/settings/public/limits', {
      params: { type }
    });
    return response.data;
  },

  getRegistrationLimits: async (): Promise<{
    full_name: number;
    email: number;
    phone: number;
    license_number: number;
    specialization: number;
    password: number;
    address: number;
    identification_number: number;
    national_chip: number;
  }> => {
    const response = await api.get('/system/settings/public/registration-limits');
    return response.data;
  },

  getUserCountInfo: async (): Promise<{
    current_count: number;
    max_users: number | null;
    remaining: number | null;
    is_full: boolean;
    limit_enabled: boolean;
  }> => {
    const response = await api.get('/system/settings/public/user-count');
    return response.data;
  },

  getPublicSetting: async (key: string): Promise<{ key: string; value: any }> => {
    const response = await api.get(`/system/settings/public/${key}`);
    return response.data;
  },

  updateSetting: async (key: string, value: string): Promise<SystemSetting> => {
    const response = await api.put(`/system/settings/${key}`, { value });
    return response.data;
  },

  bulkUpdateSettings: async (settings: SystemSettingUpdatePayload[]): Promise<SystemSetting[]> => {
    const response = await api.put('/system/settings', { settings });
    return response.data;
  },
  
  getMenuPermissions: async (): Promise<MenuPermissionsResponse> => {
    const response = await api.get('/system/menu-config/me');
    return response.data;
  },
  
  getMenuConfig: async (): Promise<MenuConfigByRole[]> => {
    const response = await api.get('/system/menu-config');
    return response.data;
  },
  
  updateMenuConfig: async (items: MenuConfigUpdateRequest): Promise<MenuConfigByRole[]> => {
    const response = await api.put('/system/menu-config', items);
    return response.data;
  },
};




